import { Subject, from } from 'rxjs';
var EventsService = /** @class */ (function () {
    function EventsService() {
        var me = this;
        me.listeners = {};
        me.eventsSubject = new Subject();
        me.events = from(this.eventsSubject);
        me.events.subscribe(function (_a) {
            var name = _a.name, args = _a.args;
            if (me.listeners[name]) {
                for (var _i = 0, _b = me.listeners[name]; _i < _b.length; _i++) {
                    var listener = _b[_i];
                    listener.apply(void 0, args);
                }
            }
        });
    }
    EventsService.prototype.on = function (name, listener) {
        if (!this.listeners[name])
            this.listeners[name] = [];
        this.listeners[name].push(listener);
        return this;
    };
    EventsService.prototype.broadcast = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.eventsSubject.next({ name: name, args: args });
    };
    EventsService.prototype.off = function (name) {
        delete this.listeners[name];
        return this;
    };
    return EventsService;
}());
export { EventsService };
